import * as types from '../mutation-types'

const state = {
	whatNow: {},
	yeastTypes: [],
	regions: [],
	varietals: [],
	countries: []
}

const mutations = {
	[types.SET_WHAT_NOW](state, whatNow) {
		state.whatNow = whatNow;
	},

	/**
	 * Yeast Type
	 */
	[types.SET_YEAST_TYPES](state, yeastTypes){
		state.yeastTypes = yeastTypes;
	},

	[types.ADD_YEAST_TYPE](state, yeastType){
		state.yeastTypes.push(yeastType);
	},

	[types.DESTROY_YEAST_TYPE](state, id){
		for(let i = 0; i < state.yeastTypes.length; i++){
			if(state.yeastTypes[i].id == id){
				state.yeastTypes.splice(i, 1);
				break;
			}
		}
	},

	[types.UPDATE_YEAST_TYPE](state, id, yeastType){
		for (let i = 0; i < state.yeastTypes.length; i++){
			if (state.yeastTypes[i].id == id){
				state.yeastTypes[i].name = yeastType.name;

				break;
			}
		}
	},

	/**
	 * Region
	 */
	[types.SET_REGIONS](state, regions){
		state.regions = regions;
	},

	[types.ADD_REGION](state, region){
		state.regions.push(region);
	},

	[types.DESTROY_REGION](state, id){
		for(let i = 0; i < state.regions.length; i++){
			if(state.regions[i].id == id){
				state.regions.splice(i, 1);
				break;
			}
		}
	},

	[types.UPDATE_REGION](state, id, region){
		for (let i = 0; i < state.regions.length; i++){
			if (state.regions[i].id == id){
				state.regions[i].name = region.name;

				break;
			}
		}
	},

	/**
	 * Varietal
	 */
	[types.SET_VARIETALS](state, varietals){
		state.varietals = varietals;
	},

	[types.ADD_VARIETAL](state, varietal){
		state.varietals.push(varietal);
	},

	[types.DESTROY_VARIETAL](state, id){
		for (let i = 0; i < state.varietals.length; i++){
			if (state.varietals[i].id == id){
				state.varietals.splice(i, 1);
				break;
			}
		}
	},

	[types.UPDATE_VARIETAL](state, id, varietal){
		for (let i = 0; i < state.varietals.length; i++){
			if (state.varietals[i].id == id){
				state.varietals[i].name = varietal.name;

				break;
			}
		}
	},

	/**
	 * Country
	 */
	[types.SET_COUNTRIES](state, countries) {
		state.countries = countries;
	}
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/settings.js